<template>
    <b-modal
        id="user-create-modal"
        ref="modal"
        :title="$t('새 사용자 생성')"
        modal-class="default-modal"
        @hidden="resetModal"
        @hide="resetModal"
    >
        <b-form id="user-create-form" @submit.prevent="submitForm">
            <b-form-group
                :label="$t('이메일 (로그인 ID)')"
                label-for="create-user-email"
            >
                <b-form-input
                    id="create-user-email"
                    v-model="form.e_mail"
                    type="email"
                    :placeholder="$t('이메일을 입력하세요')"
                    required
                    trim
                />
            </b-form-group>
            <b-form-group
                :label="$t('사용자명')"
                label-for="create-user-name"
            >
                <b-form-input
                    id="create-user-name"
                    v-model="form.user_name"
                    :placeholder="$t('사용자명을 입력하세요')"
                    required
                    trim
                />
            </b-form-group>
            <b-form-group
                :label="$t('비밀번호')"
                label-for="create-user-password"
                :description="$t('미입력 시 자동 생성됩니다.')"
            >
                <b-form-input
                    id="create-user-password"
                    v-model="form.password"
                    type="password"
                    :placeholder="$t('비밀번호 (선택)')"
                    trim
                />
            </b-form-group>
            <b-form-group
                :label="$t('사용자 레벨')"
                label-for="create-user-level"
            >
                <b-form-select
                    id="create-user-level"
                    v-model="form.is_admin"
                    :options="adminOptions"
                />
            </b-form-group>
        </b-form>
        <template #modal-footer>
            <b-button variant="outline-secondary" @click="$bvModal.hide('user-create-modal')">
                {{ $t('취소') }}
            </b-button>
            <b-button
                variant="primary"
                :disabled="!isValid || loading"
                form="user-create-form"
                type="submit"
            >
                <b-spinner v-if="loading" small class="mr-1" />
                {{ $t('생성') }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'UserCreateModal',
    props: {
        companyId: {
            type: [Number, String],
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            form: {
                e_mail: '',
                user_name: '',
                password: '',
                is_admin: 1,
            },
            adminOptions: [
                { value: 1, text: '일반 사용자' },
                { value: 2, text: '외부 평가자' },
                { value: 3, text: '캠페인 평가자' },
            ],
        };
    },
    computed: {
        isValid() {
            return this.form.e_mail && this.form.user_name;
        },
    },
    methods: {
        async submitForm() {
            try {
                this.loading = true;
                const payload = {
                    company_id: Number(this.companyId),
                    e_mail: this.form.e_mail,
                    user_name: this.form.user_name,
                    is_admin: this.form.is_admin,
                };
                if (this.form.password) {
                    payload.password = this.form.password;
                }

                const res = await this.$axios.post('/admin/company/member', payload);

                this.$bvModal.hide('user-create-modal');
                this.$emit('created', res.data);

                this.$showModal({
                    type: 'alert',
                    state: 'success',
                    title: this.$t('사용자 생성 완료'),
                    message: this.$t('사용자가 생성되었습니다.'),
                });
            } catch (e) {
                const status = e.response?.status;
                if (status === 409) {
                    this.$EventBus.$emit('toast-failure', this.$t('생성 실패'), this.$t('이미 존재하는 이메일입니다.'));
                } else if (status === 404) {
                    this.$EventBus.$emit('toast-failure', this.$t('생성 실패'), this.$t('평가 신청된 기업이 아닙니다.'));
                } else {
                    this.$EventBus.$emit('toast-failure', this.$t('생성 실패'), this.$t('사용자 생성 중 오류가 발생했습니다.'));
                }
                console.error(e);
            } finally {
                this.loading = false;
            }
        },
        resetModal() {
            this.loading = false;
            this.form = {
                e_mail: '',
                user_name: '',
                password: '',
                is_admin: 1,
            };
        },
    },
};
</script>
